import React from "react";
import AuthenticatedLayout from "../../Layouts/AuthenticatedLayout";
import { GetUrlParam } from "../../Utils/BaseUtils";
import "./home.css";

const Home = () => {
  const onlyBodyBool = GetUrlParam('onlybody');
  
  return (
    <AuthenticatedLayout onlyBody={onlyBodyBool}>
      <div>
        Sei in Home
      </div>
    </AuthenticatedLayout>
  )
};

export default Home;
